import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { logErrorToNewRelic } from "../utils/logging";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { IResponse, encryptedRequest } from "../core/api.client";
export interface ICPSubscriptionResponse {
  subscriptionFlag: number;
  cibilScore: number;
  redirectionUrl: string;
  planCode: string;
}

export const checkCPSubscription = async (): Promise<IResponse<ICPSubscriptionResponse> | null> => {
  try {
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
    const response = await createCacheAsync(
      `${API_PATHS.checkCPSubscription}-${mobileNo}`,
      encryptedRequest<ICPSubscriptionResponse>,
      {
        method: "POST",
        url: API_PATHS.checkCPSubscription,
        data: {
          mobileNo,
        },
      }
    );

    return response;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return null;
  }
};
